import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
    
    captcha: {
      maxHeight: 60,
      maxWidth: '100%',
      borderRadius: 4,
      marginInlineStart: theme.spacing(1),
      marginTop: theme.spacing(3),
    },
    captchaLoading: {
      height: 85,
      width: 200,
      borderRadius: 4,
      marginInlineStart: theme.spacing(1),
      marginBottom: theme.spacing(-0.5),
    },
 
    customCaptchaDialog: {
      display: 'flex',
      flexDirection: 'row-reverse',
      marginTop: '16px',
      gap: '15px',
      [theme.breakpoints.down('sm')]: {
        display: 'flex',
        flexDirection: 'column'
      }
    },
    captchaDialog: {
      maxHeight: 37,
      maxWidth: '100%',
      borderRadius: 4,
      marginInlineStart: theme.spacing(1),
      marginTop: theme.spacing(3),
    },
    captchaLoadingDialog: {
      height: 68,
      width: 150,
      borderRadius: 4,
      marginInlineStart: theme.spacing(1),
      marginTop: 10,
    },
    captchaBoxDialog: {
      display: 'flex',
      alignItems: 'center',
    },
    iconActionCaptchaDialog: {
      marginTop: 12
    }
  }));